import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

interface Particle {
  id: number;
  x: number;
  y: number;
  color: string;
  size: number;
  rotation: number;
  shape: 'circle' | 'square';
}

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899'];

export function Confetti() {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    const newParticles: Particle[] = Array.from({ length: 50 }).map((_, i) => ({
      id: i,
      x: 50, // Initial center X
      y: 50, // Initial center Y
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      size: Math.random() * 8 + 4,
      rotation: Math.random() * 360,
      shape: Math.random() > 0.5 ? 'circle' : 'square',
    }));
    setParticles(newParticles);
    
    // Auto-remove after animation
    const timer = setTimeout(() => setParticles([]), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (particles.length === 0) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-[9999] overflow-hidden">
      {particles.map((p) => {
        const angle = Math.random() * Math.PI * 2;
        const velocity = Math.random() * 300 + 200;
        const targetX = Math.cos(angle) * velocity;
        const targetY = Math.sin(angle) * velocity + 500; // Gravity effect

        return (
          <motion.div
            key={p.id}
            initial={{ 
              x: '50vw', 
              y: '50vh', 
              rotate: p.rotation,
              scale: 0,
              opacity: 1 
            }}
            animate={{ 
              x: `calc(50vw + ${targetX}px)`, 
              y: `calc(50vh + ${targetY}px)`,
              rotate: p.rotation + 360,
              scale: [0, 1.2, 0.8, 0],
              opacity: [1, 1, 0.8, 0]
            }}
            transition={{ 
              duration: 2.5, 
              ease: "easeOut"
            }}
            style={{
              width: p.size,
              height: p.size,
              backgroundColor: p.color,
              borderRadius: p.shape === 'circle' ? '50%' : '2px',
              position: 'absolute'
            }}
          />
        );
      })}
    </div>
  );
}
